import Styles from './ErrorState.module.scss'

export const ErrorState = () => (
  <div className={Styles.errorState}>
    <p>Could not load the workflow, please try again later.</p>
  </div>
)
